export const paymentTermEs = {
  Dashboard: `Panel`,
  catalog: `Catálogo`,
  payment_terms: `Condiciones de pago`,
  payment_term: `Condición de pago`,
  add_payment_term: `Añadir condición de pago`,
  edit_payment_term: `Editar condición de pago`,
  delete_payment_term: `Eliminar condición de pago`,
  delete_payment_term_description: `¿Seguro que quieres eliminar esta condición de pago? Esta acción no se puede deshacer.`,
  code: `Código`,
  name: `Nombre`,
  due_days: `Días de vencimiento`,
  early_payment_discount_percentage: `Descuento por pronto pago (%)`,
  early_payment_discount_days: `Días de descuento por pronto pago`,
  actions: `Acciones`,
  search: `Buscar`,
  search_placeholder: `Buscar por código o nombre`,
  filter_payment_terms: `Filtrar condiciones de pago`,
  filter_payment_terms_subtitle: `Acota la lista de condiciones de pago`,
  edit: `Editar`,
  delete: `Eliminar`,
  cancel: `Cancelar`,
  add: `Añadir`,
  update: `Actualizar`,
  code_required: `El código es obligatorio`,
  name_required: `El nombre es obligatorio`,
  due_days_required: `Los días de vencimiento son obligatorios`,
  must_be_whole_number: `Debe ser un número entero`,
  must_be_zero_or_more: `Debe ser 0 o mayor`,
  discount_percentage_required: `El porcentaje de descuento es obligatorio`,
  discount_percentage_range: `El porcentaje de descuento debe estar entre 0 y 100`,
  discount_days_required: `Los días de descuento son obligatorios`,
  no_payment_terms_found: `No se encontraron condiciones de pago`,
  payment_term_created_successfully: `Condición de pago creada correctamente`,
  payment_term_updated_successfully: `Condición de pago actualizada correctamente`,
  payment_term_deleted_successfully: `Condición de pago eliminada correctamente`,
  something_went_wrong: `Algo salió mal`,
  organization_not_found: `No se encontró organización para el usuario actual`,
  payment_term_code_required: `El código de la condición de pago es obligatorio`,
  payment_term_name_required: `El nombre de la condición de pago es obligatorio`,
  payment_term_code_duplicate: `Ya existe una condición de pago con este código`,
  payment_term_due_days_invalid: `Los días de vencimiento deben ser 0 o más`,
  payment_term_discount_percentage_invalid: `El porcentaje de descuento debe estar entre 0 y 100`,
  payment_term_discount_days_invalid: `Los días de descuento deben ser mayores que 0 y no superar los días de vencimiento cuando hay descuento, o 0 cuando no hay descuento`,
  payment_term_not_found: `Condición de pago no encontrada`,
  not_allowed_to_update_payment_term: `No tienes permiso para actualizar esta condición de pago`,
  not_allowed_to_delete_payment_term: `No tienes permiso para eliminar esta condición de pago`,
  payment_term_listing_max_100_allowed: `Se pueden listar como máximo 100 condiciones de pago por página`,
};
